import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import { equals as deepEqual } from 'ramda';
import shallowEqual from 'shallowequal';
// TODO: replace react-entanglement
// @ts-expect-error react-entanglement is not maintained and has no types
import Entanglement from 'react-entanglement';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { withDialogOptions } from '@bubble-ui/provider-dialog-options';
import { DesignContextForwardProvider, withDesignContext } from '@klarna/designtokens';
import TrapFocus from 'focus-trap-react';
import IconBackNavigation from '@bubble-ui/icon-back-navigation';
import IconClose from '@bubble-ui/icon-close';
import * as Breakpoints from '@bubble-ui/particle-breakpoints';
import NavBar from '@bubble-ui/molecule-nav-bar';
import ButtonPrimary from '@bubble-ui/molecule-button-primary';
import ButtonSecondary from '@bubble-ui/molecule-button-secondary';
import ButtonTertiary from '@bubble-ui/molecule-button-tertiary';
import ButtonQuaternary from '@bubble-ui/molecule-button-quaternary';
import { isMobileDevice } from '@bubble-ui/util-platform';
import View from '@bubble-ui/primitive-view';
import { Provider as DialogContentWidthProvider } from '@bubble-ui/provider-dialog-content-width';
import { DialogIcon } from './DialogIcon';
import { getDefaultStyleSheet, getDesktopContentSize } from './getDefaultStyleSheet';
import { CONTAINER_PADDING_TOP_KUZCO, EXTRA_PADDINGS, DESKTOP_ICON_SIZE, SIDE_PADDINGS } from './constants';
import { defaultDesignTokens } from './defaultDesignTokens';
import { Layout } from './Layout';
import { getIds } from './getIds';
var getNavBarHeight = (hasIconInNavbar, hasTitle, hideHeader) => hideHeader ? 0 : hasIconInNavbar && hasTitle ? CONTAINER_PADDING_TOP_KUZCO + DESKTOP_ICON_SIZE / 2 : CONTAINER_PADDING_TOP_KUZCO;
var MaterializedButtonPrimary = Entanglement.materialize({
  name: 'ButtonPrimary',
  constructor: ButtonPrimary
});
var MaterializedButtonSecondary = Entanglement.materialize({
  name: 'ButtonSecondary',
  constructor: ButtonSecondary
});
var MaterializedButtonTertiary = Entanglement.materialize({
  name: 'ButtonTertiary',
  constructor: ButtonTertiary
});
var MaterializedButtonQuaternary = Entanglement.materialize({
  name: 'ButtonQuaternary',
  constructor: ButtonQuaternary
});
class Dialog extends Component {
  constructor(props) {
    super(props);
    this.adapter = Entanglement.passthroughAdapter();
    this.state = {
      bottomSize: {
        height: 0
      },
      contentSize: {
        height: 0
      },
      rootSize: {
        height: 0,
        width: 0
      }
    };
    this.onContentResize = this.onContentResize.bind(this);
    this.onRootResize = this.onRootResize.bind(this);
    this.calculateWindowAndResize = this.calculateWindowAndResize.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.props.onDialogWillOpen(props);
  }
  calculateWindowAndResize() {
    if (this.bottomDomElement && this.contentDomElement && this.contentDomElementDefaultView) {
      var contentHeight = Math.floor(this.contentDomElement.getBoundingClientRect().height);
      var bottomHeight = Math.floor(this.bottomDomElement.getBoundingClientRect().height);
      var height = Math.floor(this.contentDomElementDefaultView.innerHeight);
      var width = Math.floor(this.contentDomElementDefaultView.innerWidth);
      this.setState({
        rootSize: {
          height,
          width
        },
        contentSize: {
          height: contentHeight
        },
        bottomSize: {
          height: bottomHeight
        }
      });
      if (this.props.onResize) {
        this.props.onResize({
          height,
          width
        });
      }
    }
  }
  onRootResize(_ref) {
    var {
      height,
      width
    } = _ref;
    if (this.contentDomElement && this.bottomDomElement) {
      var contentHeight = this.contentDomElement.getBoundingClientRect().height;
      var bottomHeight = this.bottomDomElement.getBoundingClientRect().height;
      var rootHeight = this.props.useWindowHeight && this.contentDomElementDefaultView ? Math.floor(this.contentDomElementDefaultView.innerHeight) : Math.floor(height);
      var rootWidth = Math.floor(width);
      this.setState({
        rootSize: {
          height: rootHeight,
          width: rootWidth
        },
        contentSize: {
          height: contentHeight
        },
        bottomSize: {
          height: bottomHeight
        }
      });
      if (this.props.onResize) {
        this.props.onResize({
          height: rootHeight,
          width: rootWidth
        });
      }
    }
  }
  onContentResize() {
    if (this.rootDomElement && this.bottomDomElement && this.contentDomElement) {
      var contentHeight = Math.floor(this.contentDomElement.getBoundingClientRect().height);
      var bottomHeight = Math.floor(this.bottomDomElement.getBoundingClientRect().height);
      var rootHeight = Math.floor(this.rootDomElement.getBoundingClientRect().height);
      var rootWidth = Math.floor(this.rootDomElement.getBoundingClientRect().width);
      var realRootHeight = this.props.useWindowHeight && this.contentDomElementDefaultView ? Math.floor(this.contentDomElementDefaultView.innerHeight) : rootHeight;
      this.setState({
        rootSize: {
          height: realRootHeight,
          width: rootWidth
        },
        contentSize: {
          height: contentHeight
        },
        bottomSize: {
          height: bottomHeight
        }
      });
    }
  }
  onKeyDown(e) {
    this.props.captureEscapeKey && e.key === 'Escape' && this.props.onClose && this.props.onClose(e);
  }
  componentDidMount() {
    if (this.props.onRef) {
      // @ts-expect-error we need to fix this
      this.props.onRef(this);
    }
    if (this.props.useWindowHeight === true && this.contentDomElementDefaultView) {
      this.contentDomElementDefaultView.addEventListener('resize', this.calculateWindowAndResize);
    }
    this.props.onDialogDidOpen(this.props);
  }
  componentDidUpdate(prevProps) {
    if (this.props.useWindowHeight === true && prevProps.useWindowHeight !== true && this.contentDomElementDefaultView) {
      this.contentDomElementDefaultView.addEventListener('resize', this.calculateWindowAndResize);
    } else if (this.props.useWindowHeight !== true && prevProps.useWindowHeight === true && this.contentDomElementDefaultView) {
      this.contentDomElementDefaultView.removeEventListener('resize', this.calculateWindowAndResize);
    }
  }
  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(null);
    }
    this.props.onDialogWillClose(this.props);
    if (this.contentDomElementDefaultView) {
      this.contentDomElementDefaultView.removeEventListener('resize', this.calculateWindowAndResize);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !deepEqual(nextState, this.state) || !shallowEqual(nextProps, this.props);
  }
  render() {
    var {
      backgroundColorToken = 'dialog/background-color',
      backgroundColorTokenArgs,
      children,
      id,
      designVersion,
      designContext,
      focusTrapActive = false,
      footer,
      klarnaLogo,
      klarnaLogoAccessibilityLabel,
      shouldTruncateTitle,
      hideIntermediatePreRender,
      isNonStickyIfShortEnough,
      isFullScreen,
      maxHeight: rawMaxheight,
      minHeight,
      MaterializedComponent,
      onBack,
      onBackgroundClick,
      onClose,
      subtitle,
      title,
      rightIconAriaLabel,
      leftIconAriaLabel,
      iconSrc,
      useWindowHeight,
      leftSidebar,
      leftSidebarWidth,
      narrowScreenBreakpoint = Breakpoints.NARROW_MAX_WIDTH,
      large,
      areButtonsHorizontal,
      isContentVerticallyCentered,
      focusTrapOptions = {},
      onOuterWrapperRef,
      UNSAFE_containerProps
    } = this.props;
    var ids = getIds(id);
    var maxHeight = rawMaxheight && (Number.isNaN(rawMaxheight) ? rawMaxheight : "".concat(rawMaxheight, "px"));
    var {
      bottomSize,
      contentSize,
      rootSize
    } = this.state;
    var isMobile = rootSize.width <= Breakpoints.MOBILE_MAX_WIDTH || rootSize.height < Breakpoints.DESKTOP_MIN_HEIGHT;
    var isNarrow = isMobile || rootSize.width <= narrowScreenBreakpoint;
    var hasIconInNavbar = Boolean(iconSrc) && !isMobile && !isFullScreen;
    var navBarHeight = getNavBarHeight(hasIconInNavbar, Boolean(title), this.props.hideHeader);
    var shouldScroll = contentSize.height + EXTRA_PADDINGS + navBarHeight + bottomSize.height > rootSize.height;
    var hasLeftSidebar = Boolean(leftSidebar === null || leftSidebar === void 0 ? void 0 : leftSidebar.length) && !isMobileDevice() && !isNarrow;
    var {
      backgroundClickHandlerStyle,
      bottomStyle,
      containerStyle,
      containerWrapperStyle,
      containerWrapperColumnsStyle,
      contentStyle,
      sidebarWrapperStyle,
      outerWrapperStyle,
      innerWrapperStyle,
      navBarWrapperStyle,
      rootStyle,
      scrollableAreaStyle,
      dialogIconContainer,
      dialogIconInlineContainer,
      footerButtonsWrapperStyle,
      buttonWrapperStyle
    } = getDefaultStyleSheet({
      areButtonsHorizontal,
      backgroundColorToken,
      backgroundColorTokenArgs,
      designVersion,
      designContext,
      isFullScreen,
      isMobile,
      isNarrow,
      isNonStickyIfShortEnough,
      shouldScroll,
      hasLeftSidebar,
      leftSidebarWidth,
      rootSize,
      contentSize,
      maxHeight,
      minHeight,
      bottomSize,
      navBarHeight,
      large,
      isContentVerticallyCentered
    });
    var dialogContentWidth = isMobile || isFullScreen ? rootSize.width - 2 * SIDE_PADDINGS : getDesktopContentSize(large, isNarrow) - 2 * (SIDE_PADDINGS + EXTRA_PADDINGS);
    var self = this;
    var content = /*#__PURE__*/React.createElement(Layout, _extends({
      id: ids === null || ids === void 0 ? void 0 : ids.root
    }, UNSAFE_containerProps, {
      style: rootStyle,
      onResize: useWindowHeight ? undefined : this.onRootResize,
      tabIndex: 0,
      onKeyDown: this.onKeyDown
    }), () => {
      var ContainerLayout = () => /*#__PURE__*/React.createElement("div", {
        style: contentStyle,
        ref: contentDomElement => {
          var _self$contentDomEleme, _self$contentDomEleme2;
          if (contentDomElement) {
            self.contentDomElement = contentDomElement;
          }
          self.contentDomElementDefaultView = (_self$contentDomEleme = self.contentDomElement) === null || _self$contentDomEleme === void 0 ? void 0 : (_self$contentDomEleme2 = _self$contentDomEleme.ownerDocument) === null || _self$contentDomEleme2 === void 0 ? void 0 : _self$contentDomEleme2.defaultView;
          if (contentDomElement) {
            var _contentDomElement$pa, _contentDomElement$pa2, _contentDomElement$pa3;
            // @ts-expect-error ParentNode is missing properties of HTMLElement
            self.rootDomElement = contentDomElement === null || contentDomElement === void 0 ? void 0 : (_contentDomElement$pa = contentDomElement.parentNode) === null || _contentDomElement$pa === void 0 ? void 0 : (_contentDomElement$pa2 = _contentDomElement$pa.parentNode) === null || _contentDomElement$pa2 === void 0 ? void 0 : (_contentDomElement$pa3 = _contentDomElement$pa2.parentNode) === null || _contentDomElement$pa3 === void 0 ? void 0 : _contentDomElement$pa3.parentNode;
            if (useWindowHeight) {
              self.calculateWindowAndResize();
            }
          }
        }
      }, /*#__PURE__*/React.createElement(Entanglement, {
        adapter: self.adapter
      }, iconSrc && (isMobile || isFullScreen) ? /*#__PURE__*/React.createElement(View, {
        style: dialogIconInlineContainer
      }, /*#__PURE__*/React.createElement(DialogIcon, {
        size: DESKTOP_ICON_SIZE,
        source: iconSrc,
        hasBorderTop: isMobile || isFullScreen
      })) : null, hideIntermediatePreRender && (!rootSize.width || !rootSize.height) ? null : children));
      return /*#__PURE__*/React.createElement(TrapFocus, _extends({
        active: focusTrapActive
      }, focusTrapActive ? {
        focusTrapOptions
      } : {}), /*#__PURE__*/React.createElement("div", {
        id: ids === null || ids === void 0 ? void 0 : ids.outerWrapper,
        style: outerWrapperStyle,
        ref: onOuterWrapperRef
      }, /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.innerWrapper,
        style: innerWrapperStyle
      }, this.props.hideHeader ? undefined : /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.navBarWrapper,
        style: navBarWrapperStyle
      }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
        context: designContext
      }, /*#__PURE__*/React.createElement(NavBar, {
        id: ids === null || ids === void 0 ? void 0 : ids.navBar,
        height: iconSrc ? navBarHeight : undefined,
        alignTitle: hasIconInNavbar ? 'end' : 'center',
        backgroundColorToken: !isMobile && !isFullScreen && !shouldScroll ? 'colors/backgrounds/transparent' : backgroundColorToken,
        backgroundColorTokenArgs: backgroundColorTokenArgs,
        iconBackgroundColorToken: "colors/backgrounds/transparent",
        leftIcon: onBack && IconBackNavigation,
        onLeftClick: onBack,
        leftIconAriaLabel: leftIconAriaLabel,
        title: title,
        hasIcon: hasIconInNavbar,
        shouldTruncateTitle: shouldTruncateTitle,
        subtitle: subtitle,
        klarnaLogo: klarnaLogo,
        klarnaLogoAccessibilityLabel: klarnaLogoAccessibilityLabel,
        rightIcon: onClose && IconClose,
        onRightClick: onClose,
        rightIconAriaLabel: rightIconAriaLabel
      }))), /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.scrollableArea,
        style: scrollableAreaStyle
      }, onBackgroundClick && /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.backgroundClickHandler,
        style: backgroundClickHandlerStyle,
        onClick: onBackgroundClick
      }), iconSrc && !isMobile && !isFullScreen ? /*#__PURE__*/React.createElement(View, {
        style: dialogIconContainer
      }, /*#__PURE__*/React.createElement(DialogIcon, {
        size: DESKTOP_ICON_SIZE,
        source: iconSrc,
        hasBorderTop: isMobile || isFullScreen
      })) : null, /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.containerWrapper,
        style: containerWrapperStyle
      }, hasLeftSidebar ? /*#__PURE__*/React.createElement(View, {
        style: containerWrapperColumnsStyle
      }, /*#__PURE__*/React.createElement(View, {
        style: sidebarWrapperStyle
      }, leftSidebar && leftSidebar.map((_ref2, index) => {
        var {
          Component,
          props
        } = _ref2;
        return /*#__PURE__*/React.createElement(Component, _extends({
          key: index
        }, props));
      })), /*#__PURE__*/React.createElement(Layout, {
        id: ids === null || ids === void 0 ? void 0 : ids.container,
        style: containerStyle,
        onResize: this.onContentResize
      }, ContainerLayout)) : /*#__PURE__*/React.createElement(Layout, {
        id: ids === null || ids === void 0 ? void 0 : ids.container,
        style: containerStyle,
        onResize: this.onContentResize
      }, ContainerLayout))), /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.bottom,
        style: bottomStyle,
        onRef: bottomDomElement => {
          this.bottomDomElement = bottomDomElement ? bottomDomElement : undefined;
          if (bottomDomElement) {
            if (useWindowHeight) {
              this.calculateWindowAndResize();
            }
          }
        }
      }, /*#__PURE__*/React.createElement(Entanglement, {
        adapter: this.adapter
      }, MaterializedComponent && /*#__PURE__*/React.createElement(MaterializedComponent, null), /*#__PURE__*/React.createElement(MaterializedButtonPrimary, null), /*#__PURE__*/React.createElement(MaterializedButtonSecondary, null), /*#__PURE__*/React.createElement(MaterializedButtonTertiary, null), /*#__PURE__*/React.createElement(MaterializedButtonQuaternary, null)), footer && footer.length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, footer.map((_ref3, index) => {
        var {
          Component,
          props
        } = _ref3;
        if (Component.displayName !== ButtonPrimary.displayName && Component.displayName !== ButtonSecondary.displayName && Component.displayName !== ButtonTertiary.displayName && Component.displayName !== ButtonQuaternary.displayName) {
          return /*#__PURE__*/React.createElement(Component, _extends({
            key: index
          }, props));
        }
      }), /*#__PURE__*/React.createElement(View, {
        id: ids === null || ids === void 0 ? void 0 : ids.footerButtonWrapper,
        style: footerButtonsWrapperStyle
      }, footer.map((_ref4, index) => {
        var {
          Component,
          props
        } = _ref4;
        if (Component.displayName === ButtonPrimary.displayName || Component.displayName === ButtonSecondary.displayName || Component.displayName === ButtonTertiary.displayName || Component.displayName === ButtonQuaternary.displayName) {
          return /*#__PURE__*/React.createElement(View, {
            key: index,
            style: buttonWrapperStyle(index === footer.length - 1)
          }, /*#__PURE__*/React.createElement(Component, props));
        }
      })))))));
    });
    return /*#__PURE__*/React.createElement(DialogContentWidthProvider, {
      value: dialogContentWidth
    }, content);
  }
}
var DialogUnwrapped = withDesignVersion(withDesignContext(defaultDesignTokens)(withDialogOptions(Dialog)));
DialogUnwrapped.displayName = 'DialogUnwrapped';
export default DialogUnwrapped;
//# sourceMappingURL=index.js.map